<template>
  <div>
    <v-dialog
      :persistent="persistent"
      v-if="isVisible"
      :value="true"
      v-bind="resetProps"
      :width="width"
      :attach="attach"
      class="app-dialog"
      @click:outside="handleOnClose"
    >
      <slot name="default">
        <v-card class="app-dialog">
          <v-card-title class="headline grey lighten-2 dialog-header">
            <slot name="header">
              <span class="d-title">{{ message.title }}</span>
              <Icon :path="require('@/assets/icons/close.svg')" width="1.3rem" @click="handleOnClose" />
            </slot>
          </v-card-title>
          <v-card-text class="dialog-body">
            <slot name="body">{{ message.body }}</slot>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="dialog-footer">
            <v-spacer border="0"></v-spacer>
            <slot name="footer">
              <Button :color="color" @click="handleOnClose" title="Done" small />
            </slot>
          </v-card-actions>
        </v-card>
      </slot>
    </v-dialog>
    <div class="app-dialog-attach" id="app-dialog-id"></div>
  </div>
</template>

<script>
const AppDialog = {
  name: "AppDrawer",

  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
  },

  props: {
    isVisible: {
      required: false,
      type: Boolean,
      default: false,
    },

    message: {
      type: Object,
      default: function () {
        return {
          title: "",
          body: "",
        };
      },
    },

    handleOnClose: {
      type: Function,
      default: () => {},
    },

    width: {
      default: "auto",
    },

    color: {
      default: "primary",
    },
    attach: {
      default: "#app-dialog-id",
    },

    persistent: {
      default: true,
      type: Boolean,
    },
  },
};

/**
 * @name App AppDialog
 * @example <AppDialog
 *             :isVisible="isDialogVisible"
 *             :handleOnClose="toggleDialog">
 *               <template #header>...</template>
 *               <template #body>...</template>
 *               <template #footer>...</template>
 *          </AppDialog>
 *
 * @param {boolean | required} isVisible
 * @param {boolean | optional} fullscreen
 * @param {boolean | string} transition
 * @param {function | required} handleOnClose
 */
export default AppDialog;
</script>

<style scoped src="./styles.scss" lang="scss" />
